import { USE_MOCK } from '@/lib/api/env';
import type { AuthApi } from './contract';
import { httpAuthApi } from './httpAuthApi';
import { mockAuthApi } from './mockAuthApi';

/** Real backend by default; `VITE_USE_MOCK=true` restores the offline demo. */
export const authApi: AuthApi = USE_MOCK ? mockAuthApi : httpAuthApi;

export type { AuthApi, MfaVerifyRequest } from './contract';
